export default "__VITE_ASSET__pozZ8483__"